import React, { Component } from 'react';

class LoadMoreButton extends Component {
  state = {
    loading: false,
  };

  render() {
    const { loading } = this.state;
    return (
      <div className="col-12 load-more-wrap text-center">
        <a
          id="load-more-cards"
          className={`${loading ? 'btn-loading' : ''} btn btn-load-more`}
          onClick={this.onloadMore}
        >
          {loading ? 'Loading...' : 'Load More'}
        </a>
      </div>
    );
  }
  onloadMore = () => {
    this.setState({
      loading: true,
    });
    this.props.loadMore().then(() => this.setState({ loading: false }));
  };
}

export default LoadMoreButton;



// WEBPACK FOOTER //
// ./src/screens/Places/LoadMoreButton.jsx